import React from 'react';
import DatahubAPI from '../../../api/DatahubAPI';
import CustomAutocomplete from 'components/Common/MUICustomAutocomplete';

interface IPEPOpts {
  formValues: any;
  setFormValues: any;
  entityTypeOpts: any;
  setEntityTypeOpts: any;
  selectedIndex: string;
  biteListPrimaryOpts: any;
  pepCountryOpts: any;
  setPepCountryOpts: any;
  countryData: any;
  toClear: boolean;
}

const PEPOptions: React.FC<IPEPOpts> = ({
  pepCountryOpts,
  setPepCountryOpts,
  biteListPrimaryOpts,
  selectedIndex,
  formValues,
  setFormValues,
  entityTypeOpts,
  setEntityTypeOpts,
  toClear,
}) => {
  const handleListNameSelect = async(e: any) => {
    const obj = {
      ...formValues,
      listName: e,
      entityType: [],
      country: [],
    };
    setFormValues(obj);
    if (obj && obj.listName.length !== 0) {
      setEntityTypeOpts({ isLoading: true, data: {} });
      setPepCountryOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        listName: obj.listName,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            addedBuckets.push(bucket.entCountryAgg.buckets);
          },
        );
      }
      setPepCountryOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };
  const handleEntityCountrySelect = async(e: any) => {
    const obj = {
      ...formValues,
      country: e,
      entityType: [],
    };
    setFormValues(obj);
    if (obj && obj.country.length !== 0) {
      setEntityTypeOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        listName: obj.listName,
        listCountry: obj.country,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            bucket.entCountryAgg.buckets.map((secondBucket: any) => {
              addedBuckets.push(secondBucket.typeAgg.buckets);
            });
          },
        );
      }
      setEntityTypeOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleEntityTypeSelect = async(e: any) => {
    setFormValues({ ...formValues, entityType: e });
  };

  return (
    <div className='wl-dropdown-container'>
      {!biteListPrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={biteListPrimaryOpts.data.countryAgg.buckets}
          placeholder='List Name'
          onChange={handleListNameSelect}
          toClear={toClear}
        />
      )}
      <CustomAutocomplete
        options={!pepCountryOpts.isLoading ? pepCountryOpts.data : []}
        placeholder='Country'
        onChange={handleEntityCountrySelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!entityTypeOpts.isLoading ? entityTypeOpts.data : []}
        placeholder='Type of Entity'
        onChange={handleEntityTypeSelect}
        toClear={toClear}
      />
    </div>
  );
};

export default PEPOptions;
